import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { FaHeart, FaShieldAlt } from 'react-icons/fa';

const BireyselYetiskinPsikoterapisi = () => {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>Bireysel Yetişkin Psikoterapisi | Psikolog Yağmur Demiröz - İstanbul</title>
        <meta 
          name="description" 
          content="Psikolog Yağmur Demiröz ile bireysel yetişkin psikoterapisi. Anksiyete, depresyon, ilişki sorunları, travma ve kişisel gelişim için profesyonel psikolojik destek. İstanbul, Etiler." 
        />
        <meta name="keywords" content="bireysel yetişkin psikoterapisi, yetişkin terapisi, psikoterapi, anksiyete tedavisi, depresyon tedavisi, travma terapisi, İstanbul psikolog, psikolojik danışmanlık" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://yagmurdemiroz.com/bireysel-yetiskin-psikoterapisi" />
        
        {/* Open Graph Tags */}
        <meta property="og:title" content="Bireysel Yetişkin Psikoterapisi - Psikolog Yağmur Demiröz" />
        <meta property="og:description" content="Anksiyete, depresyon, travma ve ilişki sorunları için profesyonel bireysel yetişkin psikoterapisi." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://yagmurdemiroz.com/bireysel-yetiskin-psikoterapisi" />
        <meta property="og:image" content="https://yagmurdemiroz.com/me.jpg" />
        
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Bireysel Yetişkin Psikoterapisi" />
        <meta name="twitter:description" content="Profesyonel psikoterapi ile kişisel gelişim ve psikolojik sağlık desteği." />
        
        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalBusiness",
            "name": "Bireysel Yetişkin Psikoterapisi - Yağmur Demiröz",
            "description": "Psikolog Yağmur Demiröz tarafından sunulan bireysel yetişkin psikoterapisi. Anksiyete, depresyon, travma ve ilişki sorunları için profesyonel destek.",
            "url": "https://yagmurdemiroz.com/bireysel-yetiskin-psikoterapisi",
            "telephone": "+90 544 135 47 54",
            "email": "pskyagmurdemiroz@gmail.com",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Nispetiye",
              "addressLocality": "Etiler, İstanbul",
              "addressCountry": "TR"
            },
            "priceRange": "$$$",
            "medicalSpecialty": ["Psychology", "Psychotherapy", "Clinical Psychology"],
            "serviceType": [
              "Bireysel Yetişkin Psikoterapisi",
              "Anksiyete Tedavisi",
              "Depresyon Tedavisi",
              "Travma Terapisi",
              "İlişki Terapisi",
              "Kişisel Gelişim"
            ],
            "provider": {
              "@type": "Person",
              "name": "Yağmur Demiröz",
              "jobTitle": "Psikolog",
              "memberOf": {
                "@type": "Organization",
                "name": "Türk Psikologlar Derneği"
              }
            },
            "hasOfferCatalog": {
              "@type": "OfferCatalog",
              "name": "Bireysel Yetişkin Psikoterapisi Hizmetleri",
              "itemListElement": [
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Bireysel Psikoterapi",
                    "description": "Yetişkinler için bireysel psikoterapi seansları"
                  }
                }
              ]
            },
            "areaServed": {
              "@type": "City",
              "name": "İstanbul"
            }
          })}
        </script>
      </Helmet>

      <div className="container mx-auto px-4 py-8">
        <header className="text-center mb-8">
          <div className="animate-fadeIn">
            <h1 className="text-4xl font-bold text-secondary">
              Bireysel Yetişkin Psikoterapisi
            </h1>
            <p className="text-lg text-gray-700 mt-2">
              Profesyonel ve gizlilik esaslı psikoterapi ile kişisel gelişim ve psikolojik sağlık desteği
            </p>
          </div>
        </header>

        <div className="flex flex-col md:flex-row items-start">
          <div className="w-full md:w-2/3 mb-6 md:mb-0">
            <div className="space-y-6">
              <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-secondary">
                <h2 className="text-2xl font-semibold text-secondary mb-4">
                  Bireysel Yetişkin Psikoterapisi Nedir?
                </h2>
                <p className="text-lg text-gray-700 leading-relaxed mb-4">
                  Bireysel yetişkin psikoterapisi, kişinin yaşadığı duygusal zorlukları, psikolojik sorunları 
                  ve kişisel gelişim alanlarını ele aldığı, güvenli ve gizliliği esas alan bir terapi sürecidir.
                </p>
                <p className="text-lg text-gray-700 leading-relaxed mb-4">
                  Bu süreçte, bireyin geçmiş deneyimleri, mevcut yaşam koşulları ve geleceğe dair hedefleri 
                  bütüncül bir bakış açısıyla değerlendirilir. Terapist ile kurulan destekleyici ilişki 
                  çerçevesinde, kişinin kendini daha iyi anlaması, duygusal farkındalık kazanması ve yaşamında 
                  daha doyumlu bir denge kurması hedeflenir.
                </p>
                <p className="text-lg text-gray-700 leading-relaxed">
                  Her bireyin ihtiyaçları farklı olduğu için, terapi süreci kişiye özel olarak planlanır ve ilerletilir.
                </p>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-md">
                <h2 className="text-2xl font-semibold text-secondary mb-4">
                  Hangi Konularda Destek Sunuyorum?
                </h2>
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="flex items-start space-x-3">
                    <FaHeart className="text-secondary text-xl mt-1 flex-shrink-0" />
                    <div>
                      <h3 className="font-semibold text-gray-800">Kaygı (Anksiyete)</h3>
                      <p className="text-sm text-gray-600">Kaygı bozuklukları ve endişe yönetimi</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <FaHeart className="text-secondary text-xl mt-1 flex-shrink-0" />
                    <div>
                      <h3 className="font-semibold text-gray-800">Depresyon</h3>
                      <p className="text-sm text-gray-600">Depresif belirtiler ve motivasyon kaybı</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <FaHeart className="text-secondary text-xl mt-1 flex-shrink-0" />
                    <div>
                      <h3 className="font-semibold text-gray-800">Duygusal Zorluklar</h3>
                      <p className="text-sm text-gray-600">Duygusal düzenleme ve farkındalık</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <FaHeart className="text-secondary text-xl mt-1 flex-shrink-0" />
                    <div>
                      <h3 className="font-semibold text-gray-800">İlişki Sorunları</h3>
                      <p className="text-sm text-gray-600">Romantik ilişkiler, aile ilişkileri, iletişim</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <FaHeart className="text-secondary text-xl mt-1 flex-shrink-0" />
                    <div>
                      <h3 className="font-semibold text-gray-800">Bağlanma Güçlükleri</h3>
                      <p className="text-sm text-gray-600">Güvenli bağlanma ve ilişki örüntüleri</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <FaHeart className="text-secondary text-xl mt-1 flex-shrink-0" />
                    <div>
                      <h3 className="font-semibold text-gray-800">Özgüven ve Kimlik Sorunları</h3>
                      <p className="text-sm text-gray-600">Benlik saygısı ve kendini tanıma</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <FaHeart className="text-secondary text-xl mt-1 flex-shrink-0" />
                    <div>
                      <h3 className="font-semibold text-gray-800">Kayıp ve Yas Süreçleri</h3>
                      <p className="text-sm text-gray-600">Kayıp deneyimleri ve uyum süreci</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <FaHeart className="text-secondary text-xl mt-1 flex-shrink-0" />
                    <div>
                      <h3 className="font-semibold text-gray-800">Tekrarlayan Yaşam Döngüleri</h3>
                      <p className="text-sm text-gray-600">Döngüsel örüntüler ve alışkanlıklar</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <FaHeart className="text-secondary text-xl mt-1 flex-shrink-0" />
                    <div>
                      <h3 className="font-semibold text-gray-800">Çocukluk Travmaları</h3>
                      <p className="text-sm text-gray-600">Geçmiş çocukluk deneyimleri ve etkileri</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <FaHeart className="text-secondary text-xl mt-1 flex-shrink-0" />
                    <div>
                      <h3 className="font-semibold text-gray-800">Stres Yönetimi</h3>
                      <p className="text-sm text-gray-600">İş stresi, yaşam stresi, tükenmişlik</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <FaHeart className="text-secondary text-xl mt-1 flex-shrink-0" />
                    <div>
                      <h3 className="font-semibold text-gray-800">Travma Sonrası Zorluklar</h3>
                      <p className="text-sm text-gray-600">Travmatik deneyimler ve uyum süreci</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <FaHeart className="text-secondary text-xl mt-1 flex-shrink-0" />
                    <div>
                      <h3 className="font-semibold text-gray-800">Kişisel Gelişim ve İçgörü</h3>
                      <p className="text-sm text-gray-600">Kendini tanıma, hedef belirleme, farkındalık</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-primary/10 to-secondary/10 p-6 rounded-lg">
                <h2 className="text-2xl font-semibold text-secondary mb-4">
                  <FaShieldAlt className="inline mr-2" />
                  Gizlilik ve Profesyonellik
                </h2>
                <p className="text-gray-700 leading-relaxed">
                  Tüm terapi seansları <strong>tamamen gizli</strong> ve <strong>Türk Psikologlar Derneği 
                  Etik Kuralları</strong> çerçevesinde yürütülür. Terapi sürecinde paylaştığınız tüm bilgiler 
                  gizlilik kapsamında korunur.
                </p>
              </div>

              {/* Related Services */}
              <section className="mt-8">
                <h2 className="text-2xl font-semibold text-secondary mb-6">Diğer Hizmetlerim</h2>
                <div className="grid md:grid-cols-3 gap-4">
                  <Link 
                    to="/moxo-testi" 
                    className="p-4 border border-gray-200 rounded-lg hover:border-secondary transition-colors group"
                  >
                    <h4 className="font-semibold text-secondary mb-2 group-hover:text-green-600 transition-colors">MOXO Testi</h4>
                    <p className="text-sm text-gray-600">Dikkat ve odaklanma değerlendirmesi</p>
                  </Link>
                  <Link 
                    to="/ogrenci-danismanligi" 
                    className="p-4 border border-gray-200 rounded-lg hover:border-secondary transition-colors group"
                  >
                    <h4 className="font-semibold text-secondary mb-2 group-hover:text-green-600 transition-colors">Öğrenci Danışmanlığı</h4>
                    <p className="text-sm text-gray-600">Akademik başarı ve motivasyon desteği</p>
                  </Link>
                  <Link 
                    to="/oyun-terapisi" 
                    className="p-4 border border-gray-200 rounded-lg hover:border-secondary transition-colors group"
                  >
                    <h4 className="font-semibold text-secondary mb-2 group-hover:text-green-600 transition-colors">Oyun Terapisi</h4>
                    <p className="text-sm text-gray-600">Çocuklar için psikolojik destek</p>
                  </Link>
                </div>
              </section>
            </div>
          </div>

          {/* Sidebar */}
          <div className="w-full md:w-1/3 md:ml-8 sticky md:top-[120px] h-fit flex flex-col justify-start">
            <div className="space-y-6">
              {/* Contact Card */}
              <div className="bg-white rounded-lg shadow-lg p-6">
                <h3 className="text-xl font-semibold text-secondary mb-4">
                  📩 Randevu ve Bilgi
                </h3>
                <p className="text-gray-700 mb-6">
                  Bireysel yetişkin psikoterapisi için randevu almak üzere iletişime geçebilirsiniz:
                </p>
                <div className="space-y-3 mb-6">
                  <a
                    href="mailto:pskyagmurdemiroz@gmail.com"
                    className="flex items-center text-secondary hover:text-green-600 transition-colors"
                  >
                    <span className="mr-2">📧</span>
                    pskyagmurdemiroz@gmail.com
                  </a>
                  <a
                    href="tel:+905441354754"
                    className="flex items-center text-secondary hover:text-green-600 transition-colors"
                  >
                    <span className="mr-2">📞</span>
                    0544 135 47 54
                  </a>
                </div>
                <a
                  href="tel:+905441354754"
                  className="w-full text-center inline-block bg-secondary text-label py-3 px-6 rounded-md hover:opacity-90 transition-all duration-300 font-semibold"
                >
                  Hemen Arayın
                </a>
              </div>

              {/* Info Card */}
              <div className="bg-white rounded-lg shadow-md p-6">
                <h4 className="font-semibold text-secondary mb-3">Seans Bilgileri</h4>
                <div className="space-y-3 text-sm text-gray-700">
                  <p><strong>Seans Süresi:</strong> 50 dakika</p>
                  <p><strong>Seans Şekli:</strong> Yüz yüze</p>
                  <p><strong>Lokasyon:</strong> Nispetiye, Etiler / İstanbul</p>
                  <p><strong>Dil:</strong> Türkçe</p>
                </div>
              </div>

              {/* FAQ Card */}
              <div className="bg-white rounded-lg shadow-md p-6">
                <h4 className="font-semibold text-secondary mb-3">Sık Sorulan Sorular</h4>
                <div className="space-y-3 text-sm">
                  <details className="cursor-pointer">
                    <summary className="font-medium text-gray-700">Terapi süreci nasıl ilerler?</summary>
                    <p className="mt-2 text-gray-600">
                      İlk seansta tanışma ve değerlendirme yapılır. Sonrasında bireysel ihtiyaçlarınıza göre terapi planı oluşturulur.
                    </p>
                  </details>
                  <details className="cursor-pointer">
                    <summary className="font-medium text-gray-700">Kaç seans gerekir?</summary>
                    <p className="mt-2 text-gray-600">
                      Terapi süresi kişiye özel olarak belirlenir. Bazı konular kısa süreli, bazıları uzun süreli destek gerektirebilir.
                    </p>
                  </details>
                  <details className="cursor-pointer">
                    <summary className="font-medium text-gray-700">Online terapi mümkün mü?</summary>
                    <p className="mt-2 text-gray-600">
                      Evet, online terapi mümkündür.
                    </p>
                  </details>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BireyselYetiskinPsikoterapisi;
